export default __webpack_public_path__ + "static/media/baby-15.453aeb98.svg";